import React, { useContext, useRef, useState, useEffect } from "react";
import SolitaireContext from "../../context/solitaireContext";
import { RUN_SCORE } from "../../utils/gameFeatures";
import { formatTime } from "../../utils/helpers";
import timePNG from "../../assets/time.png";
import trophyPNG from "../../assets/trophy.png";
import resetPNG from "../../assets/icon-reset.svg";

const ScoreBoard = () => {
  const {
    isStarted,
    createCards,
    foundations,
    reset,
    setTimeScore,
    isEnded,
    trophy,
  } = useContext(SolitaireContext);

  const timerRef = useRef(null); // Таймер
  const [time, setTime] = useState(0); // Время
  const [localTrophy, setLocalTrophy] = useState(trophy); // Локальный трофей
  const [localScore, setLocalScore] = useState(foundations * RUN_SCORE); // Локальные очки

  // Загрузка сохраненных данных из localStorage при монтировании компонента
  useEffect(() => {
    const savedProgress = JSON.parse(localStorage.getItem("solitaireProgress"));
    if (savedProgress) {
      setTime(savedProgress.time || 0);
      setLocalTrophy(savedProgress.trophy || 0);
      setLocalScore(savedProgress.score || 0);
    }
  }, []);

  // Сохранение прогресса в localStorage при каждом изменении времени, очков или трофеев
  useEffect(() => {
    localStorage.setItem(
      "solitaireProgress",
      JSON.stringify({
        time,
        trophy: localTrophy,
        score: localScore,
      })
    );
  }, [time, localTrophy, localScore]);

  // Логика таймера
  useEffect(() => {
    if (isStarted) {
      if (!timerRef.current) {
        timerRef.current = setInterval(() => {
          setTime((prev) => prev + 1);
        }, 1000);
      }
    }

    if (isEnded) {
      setTimeScore(time); // Устанавливаем итоговое время
      setLocalTrophy((prev) => prev + 1); // Увеличиваем трофей
      setLocalScore(foundations * RUN_SCORE); // Обновляем очки
      clearInterval(timerRef.current); // Останавливаем таймер
      timerRef.current = null;
    }

    return () => {
      clearInterval(timerRef.current); // Очищаем таймер при размонтировании компонента
      timerRef.current = null;
    };
  }, [isStarted, isEnded, foundations, setTimeScore, time]);

  // Сброс игры и состояния
  const handleReset = () => {
    reset();
    createCards();
    setTime(0);
    setLocalTrophy(0);
    setLocalScore(0);

    // Удаляем сохраненные данные из localStorage
    localStorage.removeItem("solitaireProgress");
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  return (
    <div className="score-board">
      <button
        data-testid="reset-btn"
        className="reset-btn"
        onClick={handleReset}
      >
        <img src={resetPNG} alt="Reset" /> <span>Заново</span>
      </button>

      <p className="trophy">
        <img src={trophyPNG} alt="Trophy" /> <span>{localTrophy}</span>
      </p>

      <p className="score">
        Счет: <span>{localScore}</span>
      </p>

      <p className="time">
        <img src={timePNG} alt="Time" /> <span>{formatTime(time)}</span>
      </p>
    </div>
  );
};

export default ScoreBoard;
